/**
 * Where the front end finds the API.
 *
 * In development the Worker runs locally on 8787. In production this has to be
 * passed in at build time, because the workers.dev subdomain is account
 * specific and is only known once the Worker has been deployed once:
 *
 *   VITE_API_BASE=https://legal-studiosus-api.<subdomain>.workers.dev npm run deploy:web
 *
 * When the real domain exists the API moves to the same origin as the site and
 * this becomes an empty string, which makes the fetch below a relative call.
 */
const configured = import.meta.env["VITE_API_BASE"] as string | undefined;

export const apiBase: string | null = configured
  ? configured.replace(/\/+$/, "")
  : import.meta.env.DEV
    ? "http://127.0.0.1:8787"
    : null;

/**
 * Whether Sign in offers a passkey. Off: Clerk includes passkeys only on its
 * Pro plan, so Mohit left them out for now (22 October 2026; PRD section 2).
 * The button stays built for the day they return, with VITE_CLERK_PASSKEYS=on
 * and passkeys turned on at Clerk; a button that cannot work is never shown.
 */
export const PASSKEY_SIGN_IN = import.meta.env["VITE_CLERK_PASSKEYS"] === "on";
